<template>
  <div class="basicInformation common_group">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <span>{{ $t('general.BasicInfo') }}</span>
    </div>
    <el-form class="common_form" label-position="left" ref="quickRjBasicInformation" :rules="rules" label-width="174px"
             :model="formData"
    >
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.an')">
            <el-input v-model="formData.activityCode" disabled />
          </el-form-item>
        </el-col>
        <!-- <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.fs')" prop="financialSystemCode">
            <el-select v-model="formData.financialSystemCode" :placeholder="$t('general.ps')"
                       :disabled="readOnlyMode || financialSystemDis"
            >
              <el-option v-for="item in financialSystemList" :key="item.comCode" :label="item.comName"
                         :value="item.comCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.toc')" prop="currencyCode">
            <el-select v-model="formData.currencyCode" :placeholder="$t('general.ps')" disabled>
              <el-option v-for="(item, index) in currencyList" :key="index" :label="item.currName"
                         :value="item.currCode"
              />
            </el-select>
          </el-form-item>
        </el-col> -->
        <!-- 申请人 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.Applicant')">
            <el-input v-model="formData.userData" disabled />
          </el-form-item>
        </el-col>
        <!-- 联系方式 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.ci')" prop="applyUserTel">
            <el-input v-model="formData.applyUserTel" :disabled="readOnlyMode" />
          </el-form-item>
        </el-col>
        <!-- 申请时间 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.at')">
            <el-input v-model="formData.applyTime" disabled />
          </el-form-item>
        </el-col>
        <!-- 对应销售 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.cs')" prop="saler">
            <el-select :disabled="readOnlyMode || (isEditable !== 0 && isEditable !== 1)" v-model="formData.saler"
                       filterable remote reserve-keyword :placeholder="$t('general.peak')" :remote-method="remoteMethod"
                       :loading="saleLoading" @change="salerChange"
            >
              <el-option v-for="item in saleList" :key="item.userId" :label="item.combination" :value="item.userId" />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 业务单元 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="businessUnitRequired">
          <el-form-item :label="$t('newApp.activityInfo.bu')" prop="businessUnitDisplayed"
                        :required="businessUnitRequired"
          >
            <el-select v-model="formData.businessUnitDisplayed" placeholder="" :disabled="readOnlyMode">
              <el-option v-for="item in unitNameList" :key="item.id" :label="item.unitName" :value="item.unitName" />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 申请分类 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.AppClass')" prop="otherClassification">
            <el-select v-model="formData.otherClassification" :disabled="readOnlyMode && !isQuickFields('otherClassification')">
              <el-option v-for="item in otherClassificationList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 活动分类 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.coa')" prop="activityClassificationCode">
            <el-select v-model="formData.activityClassificationCode"
                       :disabled="readOnlyMode || (isEditable !== 0 && isEditable !== 1)" :placeholder="$t('general.ps')"
                       @change="activityClassificationCodeChange"
            >
              <el-option v-for="(item, index) in activityClassificationList" :key="index" :label="item.fieldValue"
                         :value="item.fieldKey"
                         v-if="!($store.state.useSimplifiedForm && ['AC_01','AC_03'].includes(item.fieldKey) && formData.activityClassificationCode !== item.fieldKey)"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 活动名称 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item class="special" :label="$t('newApp.activityInfo.noa')" prop="activityName">
            <el-input v-model="formData.activityName" :disabled="readOnlyMode" maxlength="200" />
          </el-form-item>
        </el-col>
        <!-- 预计举办日期 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.edoh')" prop="expectStartDate">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" :disabled="readOnlyMode && !isFilterFields('expectStartDate')" type="datetime" :placeholder="$t('general.psad')"
                            v-model="formData.expectStartDate" :picker-options="pickerOptions" style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <!-- 预计结束日期 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.eed')" prop="expectEndDate">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" :disabled="readOnlyMode && !isFilterFields('expectEndDate')" type="datetime" :placeholder="$t('general.psad')"
                            v-model="formData.expectEndDate" :picker-options="pickerOptions" style="width: 100%;"
            />
          </el-form-item>
        </el-col>
        <!-- 活动场地查看 -->
        <el-col v-if="lang === 'zh-CN' && !$store.state.useSimplifiedForm" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.hdcdtj')">
            <div class="active-text" @click="goToLook">
              {{ $t('general.ctView') }}
            </div>
          </el-form-item>
        </el-col>
        <!-- 联合市场活动 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="belongToSmb">
          <el-form-item :label="$t('newApp.activityInfo.jma')">
            <el-radio-group v-model="formData.isUnionMarket" :disabled="readOnlyMode" @change="isUnionMarketChange">
              <el-radio :label="1">{{ $t('general.yes') }}</el-radio>
              <el-radio :label="0" :disabled="smbStatus">{{ $t('general.no') }}</el-radio>
            </el-radio-group>
            <!-- <div class="radioRroupReplace" v-else>{{ formData.isUnionMarket ? "是" : "否" }}</div> -->
          </el-form-item>
        </el-col>
        <!-- 国际渠道 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="formData.isUnionMarket === 1 && belongToSmb">
          <el-form-item :label="$t('newApp.activityInfo.ic')">
            <el-radio-group v-model="formData.isInternationalQd" :disabled="readOnlyMode"
                            @change="isInternationalQdChange"
            >
              <el-radio :label="1">{{ $t('general.yes') }}</el-radio>
              <el-radio :label="0">{{ $t('general.no') }}</el-radio>
            </el-radio-group>
            <!-- <div class="radioRroupReplace" v-else>{{ formData.isInternationalQd ? "是" : "否" }}</div> -->
          </el-form-item>
        </el-col>
        <!-- 渠道签约类型 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="formData.isUnionMarket === 1 && belongToSmb">
          <el-form-item :label="$t('newApp.activityInfo.cst')" prop="unionChannelType"
                        :required="formData.isUnionMarket === 1"
          >
            <el-select v-model="formData.unionChannelType" :disabled="readOnlyMode" :placeholder="$t('general.ps')"
                       @change="unionChannelTypeChange"
            >
              <el-option v-for="(item, index) in unionChannelTypeList" :key="index" :label="item.name"
                         :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 渠道名称 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="formData.isUnionMarket === 1 && belongToSmb">
          <el-form-item :label="$t('newApp.activityInfo.cn')" prop="unionChannelName"
                        :required="formData.isUnionMarket === 1"
          >
            <el-select :disabled="readOnlyMode" v-model="formData.unionChannelName" filterable remote reserve-keyword
                       :placeholder="$t('general.peak')" :remote-method="unionChannelRemote" :loading="unionChannelLoading"
            >
              <el-option v-for="(item, index) in unionChannelNameList" :key="index" :label="item.companyName"
                         company-name :value="item.companyName"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 活动分层 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="!belongToSbg && lang === 'zh-CN' && !$store.state.useSimplifiedForm">
          <el-form-item :label="$t('newApp.activityInfo.csl')" prop="activityLevel" :required="!belongToSbg && lang === 'zh-CN'">
            <el-select v-model="formData.activityLevel" :disabled="readOnlyMode || lang === 'zh-CN'" reserve-keyword :placeholder="$t('general.ps')">
              <el-option v-for="item in activityLevelList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldKey"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { newApplicationFormApi } from '../../service';
import { bus } from '@/utils/bus.js';
import { isNotEmpty } from '@/utils/utils';
export default {
  data () {
    let phoneNumberValidator = (rule, value, callback) => {
      if (!value) {
        callback(new Error(`${this.$t('newApp.BasicInfo.peuci')}`));
      } else {
        callback();
      }
    };
    let unionChannelTypeMessage = (rule, value, callback) => {
      if (!value && this.formData.isUnionMarket === 1) {
        callback(new Error(this.$t('newApp.activityInfo.pscst')));
      } else {
        callback();
      }
    };
    let unionChannelNameMessage = (rule, value, callback) => {
      if (!value && this.formData.isUnionMarket === 1) {
        callback(new Error(this.$t('newApp.activityInfo.psacn')));
      } else {
        callback();
      }
    };
    let dateValidator = (rule, value, callback) => {
      if (this.noBorderMode) {
        callback();
        return;
      }
      let currentDate = new Date(new Date().format('yyyy-MM-dd')).getTime();
      let startDate = new Date(
        new Date(this.formData.expectStartDate).format('yyyy-MM-dd')
      ).getTime();
      if (startDate < currentDate) {
        callback(new Error(this.$t('newApp.activityInfo.tedcblttcd')));
      } else if (this.formData.expectStartDate > this.formData.expectEndDate) {
        callback(new Error(this.$t('newApp.activityInfo.tsdcbgtted')));
      } else {
        this.$refs.quickRjBasicInformation.clearValidate([
          'expectStartDate',
          'expectEndDate'
        ]);
        callback();
      }
    };

    let businessUnitMessage = (rule, value, callback) => {
      if (value.length < 1 && this.businessUnitRequired) {
        callback(new Error(this.$t('newApp.activityInfo.psabu')));
      } else {
        callback();
      }
    };

    return {
      rules: {
        applyUserTel: [{ validator: this.$i18n.locale === 'zh-CN' ? phoneNumberValidator : null, trigger: 'blur' }],
        businessUnitDisplayed: [
          { validator: businessUnitMessage, trigger: 'change' }
        ],
        activityName: [
          { required: true, message: this.$t('newApp.activityInfo.peen'), trigger: 'blur' }
        ],
        activityClassificationCode: [
          { required: true, message: this.$t('newApp.activityInfo.psaac'), trigger: 'change' }
        ],
        city: [{ required: true, message: this.$t('newApp.activityInfo.pehc'), trigger: 'blur' }],
        activityTypeCode: [
          { required: true, message: this.$t('newApp.activityInfo.psaet'), trigger: 'change' }
        ],
        activitySubtypeCode: [
          { required: true, message: this.$t('newApp.activityInfo.Psttoa'), trigger: 'change' }
        ],
        unionChannelType: [
          { validator: unionChannelTypeMessage, trigger: 'change' }
        ],
        unionChannelName: [
          { validator: unionChannelNameMessage, trigger: 'change' }
        ],
        inviterNum: [
          { required: true, message: this.$t('newApp.activityInfo.pettnop'), trigger: 'blur' }
        ],
        financialSystemCode: [
          { required: true, message: this.$t('newApp.BasicInfo.psafs'), trigger: 'change' }
        ],
        currencyCode: [
          { required: true, message: this.$t('newApp.BasicInfo.psac'), trigger: 'change' }
        ],
        expectStartDate: [
          { required: true, message: this.$t('newApp.activityInfo.psasd'), trigger: 'change' },
          { validator: dateValidator, trigger: 'change' }
        ],
        expectEndDate: [
          { required: true, message: this.$t('newApp.activityInfo.psaed'), trigger: 'change' },
          { validator: dateValidator, trigger: 'change' }
        ],
        saler: [
          { required: true, message: this.$t('newApp.BasicInfo.pstcs'), trigger: 'change' }
        ],
        businessUnit: [
          { required: true, message: this.$t('newApp.BasicInfo.Pfitbu'), trigger: 'change' }
        ],
        otherClassification: [
          { required: true, message: this.$t('newApp.BasicInfo.Pstapc'), trigger: 'change' }
        ]
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      financialSystemList: [], // 财务体系列表
      currencyList: [], // 货币种类列表
      saleList: [], // 对应销售列表
      activityClassificationList: [], // 活动分类
      activityGoalList: [], // 活动目的
      otherClassificationList: [], // 申请目的分类列表
      activityLevelList: [], // 申请目的分类列表
      unionChannelTypeList: [], // 签约渠道类型列表
      unionChannelNameList: [], // 渠道名称列表,
      unitNameList: [], // 业务单元列表,
      formData: {
        isUnionMarket: 0,
        isInternationalQd: 0,
        businessUnitDisplayed: []
      },
      productlineOtherShow: false,
      saleLoading: false,
      readOnlyMode: false, // 只读模式
      unionChannelLoading: false, // 渠道名称loading
      businessUnitRequired: false, // 业务单元是否必填
      unionChannelRequired: false, // 渠道相关是否必填
      financialSystemDis: false,
      isEditable: 0,
      belongToSmb: false, // 是否是smb部门
      belongToSbg: false, // 是否是sbg部门
      smbStatus: false,
      lang: localStorage.getItem('lang') || 'zh-CN',
      isReadOnly: false // 是否只读

    };
  },
  props: {
    editEchoData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 无边框模式
    noBorderMode: {
      type: Boolean,
      default: false
    },
    updateForm: {
      type: Function,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    // 当前路由时(报备)部分字段可以修改
    isFilterFields () {
      const editFields = ['expectStartDate', 'expectEndDate'];
      const pathList = ['/quickTransferApplication'];
      return (fieldCode) => {
        return pathList.includes(this.$route.path) && editFields.includes(fieldCode);
      };
    },
    // 报备转申请需要补充的部分字段
    isQuickFields () {
      const activityFields = ['otherClassification'];
      return (fieldCode) => {
        return activityFields.includes(fieldCode);
      };
    }
  },
  watch: {
    editEchoData: {
      immediate: true,
      deep: true,
      handler (newVal) {
        if (isNotEmpty(newVal) && isNotEmpty(newVal.mactExpenseBelongVOList)) {
          this.smbStatus = newVal.mactExpenseBelongVOList.some(item => item.mactExpenseBelong.expenseTypeCode === 'EI172');
          this.$set(this.formData, 'isUnionMarket', this.smbStatus ? 1 : this.formData.isUnionMarket);
          this.$store.commit('newApplication/setIsUnionMarket', 1);
        } else {
          this.smbStatus = false;
          this.$store.commit('newApplication/setIsUnionMarket', 0);
        }
      }
    },
    formData: {
      immediate: true,
      deep: true,
      handler (newVal) {
        this.updateForm(newVal);
      }
    }
  },
  created () {
    bus.$on('quickType', (list) => {
      if (isNotEmpty(list)) {
        this.smbStatus = list.some(item => item.expenseTypeCode === 'EI172');
        this.$set(this.formData, 'isUnionMarket', this.smbStatus ? 1 : this.formData.isUnionMarket);
        this.$store.commit('newApplication/setIsUnionMarket', 1);
      } else {
        this.smbStatus = false;
        this.$store.commit('newApplication/setIsUnionMarket', 0);
      }
    });
  },
  destroyed () {
    // 组件销毁前需要解绑事件。否则会出现重复触发事件的问题
    bus.$off('quickType');
  },
  methods: {
    isInternationalQdChange (val) {
      this.getChannelTypeList(val);
      this.unionChannelClear();
    },
    goToLook () {
      window.open('https://ruijie.feishu.cn/share/base/query/shrcnLYaqtH3GcUGNq84cJclTTd');
    },
    unionChannelClear () {
      this.$set(this.formData, 'unionChannelType', '');
      this.$set(this.formData, 'unionChannelName', '');
      this.unionChannelNameList = [];
      this.$nextTick(() => {
        this.$refs.quickRjBasicInformation.clearValidate([
          'unionChannelType',
          'unionChannelName'
        ]);
      });
    },
    activityClassificationCodeChange (val) {
      const v = this.activityClassificationList.find(item => item.fieldKey === val);
      this.$set(this.formData, 'activityClassificationValue', v.fieldValue);
      this.$store.commit('newApplication/setActivityClassificationLoadFlag', 0);
      this.$store.commit('newApplication/setActivityClassification', val);
    },
    unionChannelTypeChange () {
      this.unionChannelNameList = [];
      this.$set(this.formData, 'unionChannelName', '');
    },
    unionChannelRemote (query) {
      if (!this.formData.unionChannelType) {
        this.$message.error(this.$t('newApp.activityInfo.pscst'));
        return;
      }
      if (query !== '') {
        let params = {
          partnerType: this.formData.unionChannelType,
          companyName: query
        };
        this.getChannelNameList(params);
      } else {
        this.unionChannelNameList = [];
      }
    },
    inviterNumFilter (val) {
      let numVal = val.replace(/[^\d]/g, '').replace(/^0{1,}/g, '');
      this.$set(this.formData, 'inviterNum', numVal);
    },
    remoteMethod (query) {
      if (query !== '') {
        this.saleLoading = true;
        newApplicationFormApi.getSalesmanList(query).then((res) => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.saleList = res.data.map((item) => {
                return {
                  ...item,
                  combination: `${item.userName}/${item.deptName}`
                };
              });
            } else {
              this.saleList = [];
            }
          }
          this.saleLoading = false;
        });
      } else {
        this.saleList = [];
      }
    },
    salerChange (val) {
      let salerObj = this.arrayQuery(val, this.saleList, 'userId');
      this.formData.salerId = salerObj.userId; // 对应销售ID
      this.formData.salerName = salerObj.userName; // 对应销售姓名
      this.formData.salerDeptCode = salerObj.deptCode; // 对应销售部门code
      this.formData.salerDeptName = salerObj.deptName; // 对应销售部门名称

      this.$store.commit('newApplication/setSalerLoadFlag', 0);
      this.$store.commit('newApplication/setSalerData', salerObj);

      this.belongToSmb = salerObj.belongToSmb;
      if (salerObj.deptCode.startsWith('000063')) {
          this.belongToSbg = true;
          this.$set(this.formData, 'activityLevel', '');
      } else {
         this.belongToSbg = false;
         if (!this.formData.activityLevel) {
             this.$set(this.formData, 'activityLevel', 'C');
         }
      }
      this.$set(this.formData, 'otherClassification', '');
      this.getFinancialSystemList(1);
      // 清除联合市场活动、国际渠道、渠道签约类型、渠道名称
      this.$set(this.formData, 'isInternationalQd', 0);
      this.$set(this.formData, 'isUnionMarket', 0);
      this.unionChannelClear();
      this.getActivityList(salerObj.deptCode);

      this.getUnitNameList(this.formData.salerDeptCode);
      this.smbStatus = false;
    },
    // 获取业务单元,判断对应销售业务单元
    getUnitNameList (code) {
      newApplicationFormApi.getUnitNameList(code).then((res) => {
        if (res.status === '200') {
          this.unitNameList = res.data;
          this.businessUnitRequired = true;
          if (code.indexOf('000062') === 0 && this.unitNameList.length > 0) {
            this.businessUnitRequired = true;
          } else {
            this.businessUnitRequired = false;
          }
        }
      });
    },
    unionChannelNameChange (val) {
      this.$store.commit('newApplication/setIsUnionMarket', val);
    },
    isUnionMarketChange (val) {
      if (val === 0) {
        this.unionChannelClear();
      }
      this.formData.isInternationalQd = 0;
      this.unionChannelNameChange(val);
    },
    arrayQuery (val, list, findKey) {
      return list.find((item) => {
        return item[findKey] === val;
      });
    },
    syncCurrencyFields () {
      if (!this.formData.currencyCode) {
        return;
      }
      const currencyObj = this.arrayQuery(this.formData.currencyCode, this.currencyList, 'currCode');
      if (currencyObj) {
        this.formData.currencyType = currencyObj.currName;
        this.formData.currFromRmbRate = currencyObj.currFromRmbRate;
        return;
      }
      this.formData.currencyType = this.formData.currencyType || this.formData.currencyCode;
      this.formData.currFromRmbRate = this.formData.currFromRmbRate || '';
    },
    getRelevanceActivityList (val) {
      let params = 'NEW';
      // 根据值获取关联活动的列表
      if (val === 'AC_03' || val === 'AC_06') {
        // 区域参加总部活动、总部重点活动
        this.relationActivityName = this.$t('home.ha');
        newApplicationFormApi.getHeadquarterActivity(params).then(res => {
          this.relationActivityList = res.data.map(item => {
            return {
              code: item.id + '',
              text: item.activityName
            };
          });
        });
      } else if (val === 'AC_01') {
        // 区域模板活动
        this.relationActivityName = this.$t('newApp.activityInfo.ta');
        newApplicationFormApi.getTemplateActivity(params).then(res => {
          this.relationActivityList = res.data.map(item => {
            return {
              code: item.id + '',
              text: item.templateName,
              activityType: item.activityType,
              activityTypeCode: item.activityTypeCode,
              activitySubType: item.activitySubType,
              activityGoal: item.activityGoal
            };
          });
        });
      } else {
        this.relationActivityShow = false;
      }
      // 控制是否需要活动组支持显隐
      if (val === 'AC_06') {
        this.needOrganizerShow = true;
      }
    },
    getDraftData () {
      // 货币name过滤
      this.syncCurrencyFields();
      // 业务单元过滤
      if (this.formData.businessUnitDisplayed && this.formData.businessUnitDisplayed.length > 0) {
        this.formData.businessUnit = this.formData.businessUnitDisplayed;
      }
      if (this.formData.activityClassificationCode) {
        // 活动分类名称过滤
        this.formData.activityClassification = this.arrayQuery(this.formData.activityClassificationCode, this.activityClassificationList, 'fieldKey').fieldValue;
      }
      // 关联活动名称过滤
      if (this.formData.relatedActivityCode && isNotEmpty(this.relationActivityList)) {
        this.formData.relatedActivityName = isNotEmpty(this.arrayQuery(this.formData.relatedActivityCode, this.relationActivityList, 'code')) ? this.arrayQuery(this.formData.relatedActivityCode, this.relationActivityList, 'code').text : '';
      }
      return this.formData;
    },
    getFormData () {
      this.$set(this.formData, 'isUnionMarket', this.smbStatus ? 1 : this.formData.isUnionMarket);
      return new Promise((resolve, reject) => {
        this.$refs['quickRjBasicInformation'].validate((valid) => {
          if (valid) {
            // 货币name过滤
            this.syncCurrencyFields();
            // 财务体系过滤
            if (this.formData.financialSystemCode !== '111') {
              const financialSystem = this.arrayQuery(this.formData.financialSystemCode, this.financialSystemList, 'comCode');
              if (financialSystem) {
                this.formData.financialSystemName = financialSystem.comName;
              }
            }
            // 业务单元过滤
            if (this.formData.businessUnitDisplayed && this.formData.businessUnitDisplayed.length > 0) {
              this.formData.businessUnit = this.formData.businessUnitDisplayed;
            }
            // 活动分类名称过滤
            this.formData.activityClassification = this.arrayQuery(this.formData.activityClassificationCode, this.activityClassificationList, 'fieldKey').fieldValue;
            // 关联活动名称过滤
            if (this.formData.relatedActivityCode && isNotEmpty(this.relationActivityList)) {
              this.formData.relatedActivityName = isNotEmpty(this.arrayQuery(this.formData.relatedActivityCode, this.relationActivityList, 'code')) ? this.arrayQuery(this.formData.relatedActivityCode, this.relationActivityList, 'code').text : '';
            }
            resolve(this.formData);
          } else {
            document.querySelector('.contentScrollbar>.el-scrollbar__wrap').scrollTop = 0;
            this.$message.error(this.$t('newApp.activityInfo.Tbicfta'));
          }
        });
      });
    },
    getActivityList (code) {
      // 活动类型--activity_type
      // 其他分类--other_classification
      // 主办方--organizer
      // 渠道会议细分--qd_meeting_segment
      // 目标对象--target_object
      // 预计板块--plate

      let params = [
        'plate', // 预计板块
        'qd_meeting_segment', // 渠道会议细分
        'activity_type', // 活动类型
        'organizer', // 主办方
        'target_object', // 目标对象
        'other_classification', // 其他分类
        'union_market_help',
        'activity_forms',
        'activity_classification',
        'productline_supplement',
        'activity_goal',
        'expense_detail_item',
        'smb_international_activity_type',
        'activity_level'
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          let { data } = res;
          this.plateList = data.plate;
          this.plateList = data.plate;
          this.qdMeetingSegmentList = data.qd_meeting_segment;
          this.organizerList = data.organizer;
          this.targetObjectList = data.target_object;
          this.activityLevelList = data.activity_level;
          if (code.startsWith('000063650007') || code.startsWith('000063657')) {
                  this.otherClassificationList = data.smb_international_activity_type;
          } else {
                  this.otherClassificationList = data.other_classification;
          }
          this.activityClassificationList = data.activity_classification;
          this.activityGoalList = data.activity_goal;
          this.activityFormsList = data.activity_forms;
          this.productlineSupplementList = data.productline_supplement;

          if (this.$route.query.activityCode) {
            // 旧活动类型过滤
            if (this.formData.activityTypeCode) {
              let activityTypeObj = this.arrayQuery(this.formData.activityTypeCode, this.activityTypeList, 'fieldKey');
              if (!activityTypeObj) {
                this.$set(this.formData, 'activityTypeCode', '');
                this.$set(this.formData, 'activityType', '');
              }
            }
          }
           // 对应销售为平台管理部时候不可以看到总部活动
          else if (code.startsWith('000062692')) {
             this.activityClassificationList = data.activity_classification.filter(item => {
                  return item.fieldKey !== 'AC_06';
            });
          }
        }
      });
    },
    getFinancialSystemList (flage) {
      newApplicationFormApi.getFinancialSystemList(this.formData.salerId).then((res) => {
        if (res.status === '200') {
          if (flage) {
            if (isNotEmpty(res.data)) {
                let defaultValFlag = res.data.some((item) => {
                  return item.comCode === '111';
                });
                // 如果新建申请 财务体系中没有福州 则默认第一个
                if (!defaultValFlag) {
                  this.$set(
                    this.formData,
                    'financialSystemCode',
                    res.data[0].comCode
                  );
                  this.formData.financialSystemName = res.data[0].comName;
                } else {
                  // 财务体系默认为福建
                  this.$set(this.formData, 'financialSystemCode', '111');
                  this.formData.financialSystemName = this.$t('general.fujian');
                }
            }
          }
          this.financialSystemList = res.data;
        }
      });
    },
    getCurrencyList () {
      newApplicationFormApi.getCurrencyList().then((res) => {
        if (res.status === '200') {
          this.currencyList = res.data;
        }
      });
    },
    getActivityCode () {
      newApplicationFormApi.getActivityCode().then((res) => {
        if (res.status === '200') {
          this.$store.commit('newApplication/setActivityCode', res.data.code);
          this.$set(this.formData, 'activityCode', res.data.code);
          this.$set(this.formData, 'applyTime', res.data.creatTime);
          bus.$emit('activityCode', this.formData.activityCode);
        }
      });
    },
    getChannelTypeList (internationalFlag) {
      let params = internationalFlag ? 1 : 0;
      newApplicationFormApi.getChannelTypeList(params).then((res) => {
        if (res.status === '200') {
          if (params) {
            this.unionChannelTypeList = res.data;
            return;
          }
          this.unionChannelTypeList = res.data.filter((item) => {
            return item.deptType === 'smb';
          });
        }
      });
    },
    getChannelNameList (params) {
      this.unionChannelLoading = true;
      let interfaceFun = this.formData.isInternationalQd
        ? newApplicationFormApi.getInternationalNameList(params)
        : newApplicationFormApi.getChannelNameList(params);
      interfaceFun.then((res) => {
        if (res.status === '200') {
          this.unionChannelNameList = res.data;
        }
        this.unionChannelLoading = false;
      });
    },
    getSalerData (userId, newFlag) {
      if (userId) {
        newApplicationFormApi.getSalesmanList(userId).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              const result = JSON.parse(JSON.stringify(res.data));
              const userIdIndex = result.findIndex(item => item.userId === userId);
              if (userIdIndex === -1) {
                let userInfo = this.$store.state.userInfo;
                result.unshift({
                  belongToSmb: userInfo.belongToSmb,
                  deptCode: userInfo.sysUser.deptCode,
                  deptName: userInfo.sysUser.deptName,
                  phone: userInfo.phone,
                  userId: userInfo.sysUser.userId,
                  userName: userInfo.sysUser.userName
                });
              } else {
                const currentUser = result.splice(userIdIndex, 1)[0];
                result.unshift(currentUser);
              }
              this.saleList = result.map(item => {
                return {
                  ...item,
                  combination: `${item.userName} / ${item.deptName}`
                };
              });
              const userIndex = this.saleList.findIndex(
                item => item.combination === this.formData.userData
              );
              const index = userIndex !== -1 ? userIndex : 0;
              this.$set(this.formData, 'saler', this.saleList[index].combination);
              this.formData.salerId = this.saleList[index].userId;// 对应销售ID
              this.formData.salerName = this.saleList[index].userName;// 对应销售姓名
              this.formData.salerDeptCode = this.saleList[index].deptCode;// 对应销售部门code
              this.formData.salerDeptName = this.saleList[index].deptName;// 对应销售部门名称
              this.belongToSmb = this.saleList[index].belongToSmb;
              if (this.saleList[index].deptCode.startsWith('000063')) {
                  this.belongToSbg = true;
                  this.$set(this.formData, 'activityLevel', '');
              } else {
                this.belongToSbg = false;
                if (!this.formData.activityLevel) {
                    this.$set(this.formData, 'activityLevel', 'C');
                }
              }
              // this.belongToQyw = this.saleList[0].belongToQyw;
              this.getFinancialSystemList(newFlag);
              this.$store.commit('newApplication/setSalerLoadFlag', 1);
              this.$store.commit('newApplication/setSalerData', this.saleList[0]);
            }
          }
        });
      }
    },
    /**
     * 修改字段
     */
    updateValue (key, val) {
      // this.formData[key] = val;
      this.$set(this.formData, key, val);
    }
  },
  mounted () {
    let userInfo = this.$store.state.userInfo;
    if (this.$route.query.activityCode) {
      // 编辑处理
      if (this.$store.state.newApplication.editFlag) {
        // 详情页跳转过来 可编辑控制
        this.isEditable = this.$store.state.newApplication.editFlag;
        let flag = Number(this.$store.state.newApplication.editFlag);
        if (flag === 3) {
          this.readOnlyMode = true;
        }
      }
      // 编辑回显
      this.formData = {
        ...this.formData,
        ...this.editEchoData.marketActivity
      };
      this.formData.userData = `${this.formData.applyUserName} / ${this.formData.applyUserDeptName}`;
      // 对应销售回显处理
      if (this.formData.salerId) {
        this.getSalerData(this.formData.salerId);
      }

      // 获取业务单元列表
      if (this.formData.salerDeptCode) {
        this.getUnitNameList(this.formData.salerDeptCode);
        this.getActivityList(this.formData.salerDeptCode);
      }

      // 业务单元回显处理
      if (this.formData.businessUnit) {
        // this.formData.businessUnitDisplayed = this.formData.businessUnit;
        this.$set(this.formData, 'businessUnitDisplayed', this.formData.businessUnit);
      }
      // 活动分类回显处理
      if (this.formData.activityClassificationCode) {
        this.relationActivityShow = true;
        this.$store.commit('newApplication/setActivityClassificationLoadFlag', 1);
        this.$store.commit('newApplication/setActivityClassification', this.formData.activityClassificationCode);
        // 如果选择总部活动，则关联活动不必填
        if (this.formData.activityClassificationCode === 'AC_06' || this.formData.activityClassificationCode === 'AC_02') {
          this.relationActivityRequired = false;
        } else {
          this.relationActivityRequired = true;
        }
        this.getRelevanceActivityList(this.formData.activityClassificationCode);
      }
      // 联合市场活动处理
      if (this.formData.isUnionMarket) {
        this.$store.commit('newApplication/setIsUnionMarket', this.formData.isUnionMarket);
      }
      // 国际渠道回回显
      if (this.formData.isInternationalQd) {

      }
      // if (this.formData.businessUnit) {
      //   this.formData.businessUnitDisplayed = this.formData.businessUnit;
      // }
      // 渠道名称回显
      // if (this.formData.unionChannelName) {
      //   this.formData.unionChannelName = this.formData.unionChannelName;
      // }

      // this.getFinancialSystemList(); // 获取财务体系列表
      this.getCurrencyList(); // 获取货币种类列表
      this.$nextTick(() => {
        this.$refs.quickRjBasicInformation.clearValidate();
      });
    } else {
      // 新增数据初始化
      // 申请人
      this.formData.userData = `${userInfo.sysUser.userName} / ${userInfo.sysUser.deptName}`;

      this.getSalerData(userInfo.sysUser.userId, 1); // 获取对应销售数据

      // this.$set(this.formData, 'financialSystemCode', '111'); // 财务体系默认为福州
      // this.formData.financialSystemName = this.$t('general.fujian');
      this.formData.currencyCode = 'CNY'; // 货币默认为人民币
      // this.getFinancialSystemList(1); // 获取财务体系列表
      this.getCurrencyList(); // 获取货币种类列表

      this.$set(this.formData, 'applyUserTel', userInfo.phone);
      this.formData.applyUserId = userInfo.sysUser.userId;
      this.formData.applyUserName = userInfo.sysUser.userName;
      this.formData.applyUserDeptCode = userInfo.sysUser.deptCode;
      this.formData.applyUserDeptName = userInfo.sysUser.deptName;
      this.formData.applyUserType = userInfo.userType;
      this.formData.needOrganizer = 0;

      this.getActivityCode(); // 获取活动编号及申请时间
      this.getUnitNameList(userInfo.sysUser.deptCode);
      this.getActivityList(userInfo.sysUser.deptCode); // 获取[活动分类,活动目的,活动形式,产品线]列表
    }
    if (this.$route.path === '/quickTransferApplication') {
      if (this.editEchoData.marketActivity.reportType === 2 && this.editEchoData.marketActivityExpand.marketingForm === 2) {
        this.formData.activityClassificationCode = 'AC_06';
      }
      this.readOnlyMode = true;
    }
    this.getChannelTypeList(this.formData.isInternationalQd); // 获取渠道签约类型列表
  }
};
</script>

<style lang="scss" scoped>
.basicInformation {
  .specialRequired textarea {
    min-height: 70px !important;
  }

  .viewIndustryAgendaCascader {
    >.el-cascader__tags>.el-tag:first-child {
      max-width: 74%;
    }
  }
}
.active-text{
  color:#14937b;
  cursor: pointer;
}
</style>
